import { ProviderSelectionAPI } from '../../../api/bussched/ProviderSelectionAPI';

export class ProviderSelectionsCommand {
    get(successCallback, errorCallback) {
        const apiResult = ProviderSelectionAPI.get();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as opções anteriormente selecionadas");
            }
        });
    }

    getTml(successCallback, errorCallback) {
        const apiResult = ProviderSelectionAPI.getTml();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as opções anteriormente selecionadas");
            }
        });
    }

    getTmlData(type, code, successCallback, errorCallback) {
        const apiResult = ProviderSelectionAPI.getTmlData(type, code);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as opções anteriormente selecionadas");
            }
        });
    }

    update(providerSelections, successCallback, errorCallback) {
        const apiResult = ProviderSelectionAPI.update(providerSelections);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as opções anteriormente selecionadas");
            }
        });
    }

    updateTml(providerSelections, successCallback, errorCallback) {
        const apiResult = ProviderSelectionAPI.updateTml(providerSelections);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as opções anteriormente selecionadas");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/ProviderSelectionsCommand.js